import { Tabs, TabsProps } from 'antd';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

// components

// services
import { isRTL } from 'core/services/language';
import PageTitle from 'components/title/title';
import authService from 'core/services/auth';

// styles

// models

const CompanyInformationPage: FunctionComponent = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const { t } = useTranslation();

	const tabItems: TabsProps['items'] = [
		{
			id: '1',
			key: 'overview',
			label: t('COMPANY_INFORMATION.OVERVIEW'),
			destroyInactiveTabPane: true,
		},
		{
			id: '2',
			key: 'payments',
			label: t('COMPANY_INFORMATION.PAYMENTS'),
			destroyInactiveTabPane: true,
		},
		{
			id: '3',
			key: 'data-room',
			label: t('COMPANY_INFORMATION.DATA_ROOM'),
			destroyInactiveTabPane: true,
		},
		{
			id: '4',
			key: 'financial-statement',
			label: t('COMPANY_INFORMATION.FINANCIAL_STATEMENT'),
			destroyInactiveTabPane: true,
		},
		authService.isPermittedToAction('updateBrandIdentity') && {
			id: '5',
			key: 'brand-identity',
			label: t('COMPANY_INFORMATION.BRAND_IDENTITY'),
			destroyInactiveTabPane: true,
		},
	].filter(Boolean) as TabsProps['items'];

	const getActiveTab = () => {
		const activeTab = tabItems?.find((tab) => tab.key === location.pathname.split('/').pop());
		if (activeTab) return activeTab?.key;
		return 'overview';
	};

	return (
		<>
			<PageTitle name={t('TITLE.COMPANY_INFORMATION')} />

			<Tabs
				activeKey={getActiveTab()}
				items={tabItems}
				size="large"
				onTabClick={(key) => navigate(`/dashboard/company-information/${key}`)}
				direction={isRTL() ? 'rtl' : 'ltr'}
			/>

			<Outlet />
		</>
	);
};

export default CompanyInformationPage;
